import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {DisposableObject} from "../../../../utils/disposable-object";
import {NullableUndefinedNumber, NullableUndefinedString} from "../../../../common/types/nullable-types";
import {CIPropRead} from "../../../../utils/case-insensitive-property-reader";
import {Check} from "@sparkware/app-utils";

export abstract class ExternalLinkHandlerBase extends DisposableObject {
    constructor(protected readonly services: IServiceFactoryExtended) {
        super()
    }

    protected _parseMessageData(message: MessageEvent): any {
        if(Check.isString(message.data)) {
            try {
                return JSON.parse(message.data);
            } catch (err) {
                this.services.logger.error(`Failed to parse external link post message data: ${message.data}`, err);
            }

        }

        return message.data;
    }

    protected _extractActionId(message: MessageEvent): NullableUndefinedString {
        return CIPropRead.getStringProperty('actionId', this._parseMessageData(message));
    }

    protected _extractUrl(message: MessageEvent): NullableUndefinedString {
        return CIPropRead.getStringProperty('url', this._parseMessageData(message));
    }

    protected _extractGameId(message: MessageEvent): NullableUndefinedNumber {
        return CIPropRead.getNumericProperty('gameId', this._parseMessageData(message));

    }

    protected async _ensureUserIsLoggedIn(): Promise<boolean> {
        await this.services.user.waitForAutoLogin();
        if(!this.services.user.isAuthorized) {
            try {
                await this.services.user.openLogin();
            } catch (err) {
                this.services.logger.debug('User canceled the login', err);
            }
        }

        return this.services.user.isAuthorized;
    }
}